import { COOKIES, MonthInMs } from "constants/enum";

export const storeIsLeadFromDrSmile = () => {
    const expiresDate = new Date(Date.now() + 3 * MonthInMs);

    document.cookie = `${
        COOKIES.DR_SMILE_SERVICE_IS_LEAD_FROM_DRSMILE_COOKIE
    }=true;path=/;expires=${expiresDate.toUTCString()}`;
};
